const multiPairSyncAbi = [
	{
		"inputs": [
			{
				"internalType": "address[]",
				"name": "pairs",
				"type": "address[]"
			}
		],
		"name": "syncMultiplePairs",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "pair",
				"type": "address"
			}
		],
		"name": "syncPositionForPair",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract LPSeeder",
				"name": "_lpSeeder",
				"type": "address"
			}
		],
		"stateMutability": "nonpayable",
		"type": "constructor"
	}
]
export default multiPairSyncAbi;